export function initSearchFilter() {
  const groups = document.querySelectorAll('.po-post-filter__group');
  const sortButtons = document.querySelectorAll('.po-post-filter__order-btn');
  const filter = document.querySelector('.po-post-filter');
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const tag = params.get('tag');

  groups.forEach((group) => {
    group.addEventListener('click', function (e) {
      e.preventDefault();
      const isAll = this.dataset.category === 'all';
      const slug = this.dataset.slug;
      let selected = params.getAll('category[]');

      if (isAll) {
        [...params.keys()].forEach((key) => {
          if (key.startsWith('category')) {
            params.delete(key);
          }
        });
      } else {
        if (selected.includes(slug)) {
          selected = selected.filter((cat) => cat !== slug);
        } else {
          selected.push(slug);
        }
        [...params.keys()].forEach((key) => {
          if (key.startsWith('category')) {
            params.delete(key);
          }
        });
        selected.forEach((cat) => params.append('category[]', cat));
      }

      if (tag) params.set('tag', tag);

      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

  sortButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const order = this.dataset.order;
      params.set('orderby', 'date');
      params.set('order', order);

      if (tag) params.set('tag', tag);

      url.search = params.toString();
      window.location.href = url.toString();
    });
  });

  if (filter) {
    filter.addEventListener('click', () => {
      if (window.innerWidth < 720) {
        filter.classList.toggle('po-post-filter_open');
      }
    });
  }
}
